module.exports = marked;


//////////////////
// WEBPACK FOOTER
// external "marked"
// module id = W78t
// module chunks = 126 127 128